<template>
  <v-container fluid>
    <v-sheet :height="height" class="overflow-y-auto">
      <v-row no-gutters v-for="colorRow in colorList" :key="colorRow">
        <v-sheet
            v-for="colorCol in light"
            :key="colorCol"
            :color="colorRow + ' ' + colorCol"
            height="24"
            width="80"
            class="mr-1 mb-1"
            @click="onClick(colorRow + ' ' + colorCol)"
        >
          <v-icon
              v-if="colorClass === colorRow + ' ' + colorCol"
              small
              class="d-flex justify-center mt-1"
          >
            mdi-chevron-down-circle-outline
          </v-icon>
        </v-sheet>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import colorClass from "@/commonFunction/colorClassDict"


export default {
  name: 'BaseColorPicker',
  props: {
    value: {type: [String], default: null},
    height: {type: [Number], default: 600},
    readonly: {type: [Boolean], default: false},
  },

  components: {},

  watch: {
    value: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.colorClass = this.getClassFromColor(newValue)
      },
      deep: false
    }
  },

  computed: {},

  methods: {
    getColorFromClass: colorClass.getColorFromClass,
    getClassFromColor: colorClass.getColorClass,

    onClick(colorClass) {
      console.log('onClick', colorClass)
      if (this.readonly)
        return
      this.colorClass = colorClass
      const color = '#' + this.getColorFromClass(colorClass)
      this.$emit('input', color)
    },
  },

  async mounted() {
  },

  data() {
    return {
      colorClass: null,
      colorPoint: 0,
      colorList: [
        'red', 'pink', 'purple',
        'deep-purple', 'indigo', 'blue',
        'light-blue', 'cyan', 'teal',
        'green', 'light-green', 'lime',
        'yellow', 'amber', 'orange',
        'deep-orange', 'brown', 'blue-grey',
        'grey',
      ],
      light: [
        'lighten-5',
        'lighten-4',
        'lighten-3',
        'lighten-2',
      ],
    }
  }
}
</script>

<style scoped lang="scss">
</style>
